import { useAppSelector } from "@vv/state";
import { ROUTES } from "@vv/types";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

export function PublicOnlyRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useAppSelector((state) => state.auth.status === "authenticated");

  if (isAuthenticated) {
    return <Navigate to={ROUTES.home} replace />;
  }

  return <>{children}</>;
}
